import { useState, useEffect } from 'react';
import { agencies, Agency } from '../api/agencies';
import { useAlert } from '../contexts/AlertContext';
import { useAuth } from '../contexts/AuthContext';
import { UserRole } from '../api/users';

const useAgenciesList = () => {
  const [agenciesList, setAgenciesList] = useState<Agency[]>([]);
  const { showAlert } = useAlert();
  const { userData } = useAuth();

  useEffect(() => {
    const fetchAgencies = async () => {
      try {
        if (userData?.role === UserRole.ADMIN) {
          const data = await agencies.getAll();
          setAgenciesList(data);
        } else {
          setAgenciesList(userData?.agencies || []);
        }
      } catch (error) {
        showAlert('Failed to load agencies', 'error');
      }
    };

    fetchAgencies();
  }, [userData, showAlert]);

  return { agenciesList };
};

export default useAgenciesList;
